import { reduxSetter } from '../../../../../utils/reduxSetter';

const initialState = {
    isLoading: true,
    existingStock: [],
    error: null,
};

export const Lead_existing_stock = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_EXISTING_STOCK_DATA':
        return reduxSetter(state, action);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_existing_stock.reducer.js